import styled from 'styled-components/macro';
import SimpleButton from 'styled/Buttons/SimpleButton';

const Roles = styled(SimpleButton)`
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  width: 180px;
  padding: 2px 0;
`;

export default Roles;
